import * as z from "zod";

export const getMarketingAgentSplitTestStatisticalSignificance = {
  name: "getMarketingAgentSplitTestStatisticalSignificance" as const,
  input: z.object({
    teamId: z.string(),
    splitId: z.string(),
    days: z.number(),
  }),
  output: z
    .object({
      pValue: z.number().min(0).max(1),
      percentageImprovement: z.number().nullable(),
      variantTrafficPercentage: z.number().min(0).max(100),
      improvementDirection: z.enum(["better", "worse", "comparable"]),
    })
    .nullable(),
};
